import React, { createContext, useContext, useState, ReactNode } from 'react';
import { Language } from '../types';

interface LanguageContextType {
  language: Language;
  toggleLanguage: () => void;
  t: (key: string) => string;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

const translations = {
  tr: {
    // Navigation
    home: 'Ana Sayfa',
    about: 'Hakkımızda',
    products: 'Ürünlerimiz',
    media: 'Medya',
    contact: 'İletişim',
    
    // Homepage
    heroTitle: 'Aymer Safety',
    heroSubtitle: 'Denizcilik yangın güvenlik sistemleri',
    statsTitle: 'Rakamlarla Aymer Safety',
    experienceYears: 'Yıllık Deneyim',
    completedProjects: 'Tamamlanan Proje',
    happyCustomers: 'Mutlu Müşteri',
    countries: 'Ülke',
    servicesTitle: 'Hizmet Alanlarımız',
    fireDetectionService: 'Yangın Algılama',
    fireDetectionDesc: 'Modern teknoloji ile erken uyarı sistemleri',
    fireExtinguishingService: 'Yangın Söndürme',
    fireExtinguishingDesc: 'Etkili ve hızlı müdahale sistemleri',
    marineEquipmentService: 'Denizcilik Ekipmanları',
    marineEquipmentDesc: 'Uluslararası standartlarda güvenlik ekipmanları',
    whyChooseTitle: 'Neden Aymer Safety',
    securityPriority: 'Güvenlik Önceliği',
    securityPriorityDesc: 'En yüksek güvenlik standartları ile hizmet veriyoruz.',
    marineExpertise: 'Denizcilik Uzmanlığı',
    marineExpertiseDesc: 'Yılların deneyimi ile profesyonel çözümler.',
    fireSafety: 'Yangın Güvenliği',
    fireSafetyDesc: 'Modern teknoloji ile yangın koruma sistemleri.',
    ctaTitle: 'Projeleriniz İçin Bizimle İletişime Geçin',
    ctaDescription: 'Denizcilik yangın güvenlik sistemleri konusunda uzman ekibimizle tanışın ve projeleriniz için en uygun çözümleri keşfedin.',
    contactUs: 'İletişime Geç',
    
    // About
    aboutTitle: 'Hakkımızda',
    aboutContent1: 'Aymer Safety, 2019 yılında İstanbul, Tuzla tersaneler bölgesinde kurulmuştur. Kuruluşundan itibaren ilk olarak kara sektöründe fabrika, atölye ve alışveriş merkezlerine hizmet vermeye başlamıştır. Daha sonra fabrika, belediye ve otellerin yangın algılama sistemleri, kamera sistemleri ve yangın söndürme sistemleri hizmetlerini üstlenmiştir. Hızla büyüyen Aymer, gemi kaptanlığı, yerel pazarlarda satış müdürlüğü ve teknik müdürlük deneyimine sahip uzmanlardan oluşan ekibiyle denizcilik sektöründeki ilk adımlarını atmıştır.',
    aboutContent2: 'Aymer Shipping, müşterilerinin dikkatini çeken kalite ve güven anlayışıyla adından söz ettirmiştir. Daha sonra ürün portföyünü genişleterek ithalata başlamıştır. Bu esnada birçok yerli ve yabancı filo şirketine hizmet verme fırsatı bulmuştur. Kısa sürede çok yol kat eden Aymer, prensiplerini benimseyerek yoluna tüm hızıyla devam edecektir. Şirketimiz en iyi hizmeti sunmak için toplam 380 m2 ofis ve depo ile hizmet vermektedir. 2 yıl garanti kapsamındadır.',
    aboutContent3: 'Firmamızda kullanılan bütün malzemeler CE onaylıdır.',
    aboutThankYou: 'BİZİ TERCİH ETTİĞİNİZ İÇİN TEŞEKKÜR EDERİZ',
    whoAreWe: 'BİZ KİMİZ?',
    moreInfo: 'Daha Fazla Bilgi',
    numbersTitle: 'RAKAMLARLA AYMER SAFETY',
    vision: 'Vizyon',
    mission: 'Misyon',
    visionText: 'Denizcilik sektöründe yangın güvenlik sistemlerinde dünya çapında lider olmak ve teknoloji ile güvenliği birleştiren yenilikçi çözümler sunmak.',
    missionText: 'Müşterilerimizin can ve mal güvenliğini en üst düzeyde koruyarak, kaliteli ürünler ve profesyonel hizmetler sunmak. Denizcilik sektöründe güvenlik standartlarını yükseltmek.',
    companyValues: 'Değerlerimiz',
    quality: 'Kalite',
    qualityDesc: 'En yüksek kalite standartlarında ürün ve hizmet',
    reliability: 'Güvenilirlik',
    reliabilityDesc: 'Müşteri memnuniyeti odaklı güvenilir çözümler',
    innovation: 'İnovasyon',
    innovationDesc: 'Teknolojik gelişmeleri takip eden yenilikçi yaklaşım',
    
    // Team
    ourTeam: 'Ekibimiz',
    generalManager: 'Genel Müdür',
    personnelManager: 'Personel Müdürü',
    
    // Products
    productsTitle: 'Ürünlerimiz',
    fireExtinguishers: 'Fire Extinguishers',
    fireDetectionSystems: 'Fire Detection Systems',
    fireExtinguishingSystems: 'Fire Extinguishing Systems',
    fireFightingEquipments: 'Fire Fighting Equipments',
    lifeSavingAppliances: 'Life Saving Appliances (LSA)',
    chartsPublications: 'Charts And Publications',
    personalProtectiveEquipments: 'Personal Protective Equipments',
    medicalEquipments: 'Medical Equipments',
    electronicEquipments: 'Electronic Equipments',
    ispsEquipments: 'ISPS Equipments',
    storageBoxEquipments: 'Storage Box And Equipments',
    oilSpillEquipments: 'Oil Spill Equipments',
    
    // Media
    mediaTitle: 'Medya Galerisi',
    mediaSubtitle: 'Projelerimiz, ürünlerimiz ve hizmetlerimiz hakkında görsel ve video içerikler',
    
    // Certificates
    certificatesTitle: 'Sertifikalarımız',
    certificatesSubtitle: 'Uluslararası standartlarda hizmet kalitemizi belgeleyen sertifikalarımız',
    qualityStandards: 'Kalite Standartlarımız',
    security: 'Güvenlik',
    securityDesc: 'En yüksek güvenlik standartları',
    qualityControl: 'Kalite',
    qualityControlDesc: 'Sürekli kalite kontrol süreçleri',
    compliance: 'Uygunluk',
    complianceDesc: 'Uluslararası standartlara uygunluk',
    
    // Contact
    contactTitle: 'İletişim',
    location: 'Konum',
    officeLocation: 'Ofis Konumumuz',
    officeLocationDesc: 'Tuzla, İstanbul merkezli hizmet veriyoruz',
    openInMaps: 'Google Maps\'te Aç',
    companyInfo: 'Şirket Bilgileri',
    address: 'Adres',
    phone: 'Telefon',
    email: 'E-posta',
    contactForm: 'İletişim Formu',
    name: 'Ad',
    surname: 'Soyad',
    yourEmail: 'E-posta Adresiniz',
    message: 'Mesajınız',
    send: 'Gönder',
    
    // Footer
    quickLinks: 'Hızlı Bağlantılar',
    contactInfo: 'İletişim Bilgileri',
    services: 'Hizmetlerimiz',
    footerDescription: 'Denizcilik sektöründe yangın güvenlik sistemlerinde uzman çözümler sunuyoruz. 25 yılı aşkın deneyimimizle güvenliğiniz bizim önceliğimiz.',
    fireDetectionSystems: 'Yangın Algılama Sistemleri',
    fireExtinguishingSystems: 'Yangın Söndürme Sistemleri',
    emergencyLighting: 'Acil Durum Aydınlatması',
    safetyEquipments: 'Güvenlik Ekipmanları',
    marineElectronics: 'Denizcilik Elektronikleri',
    protectiveClothing: 'Koruyucu Giyim',
    privacyPolicy: 'Gizlilik Politikası',
    termsOfUse: 'Kullanım Şartları',
    cookiePolicy: 'Çerez Politikası',
    allRightsReserved: 'Tüm hakları saklıdır.',
    
    // Company Info
    companyAddress: 'İçmeler Mah. Göktürk Cad. No 76/A Tuzla/Istanbul/Türkiye',
    companyPhone: '+90 216 392 28 93 / +90 546 833 56 66',
    companyEmail: 'info@aymersafety.com',
    
    // Services
    servicesWeProvide: 'Sağladığımız Hizmetler',
    inspectionRepairCertification: 'Muayene, Onarım ve Belgelendirme',
    inflatableLifesavingAppliances: 'Şişirilebilir can kurtarma araçları: düşürülen ve alçalan türden sallar (ve diğer üreticiler), kurtarma botları, can yelekleri',
    dawitLifeboatWinches: 'D-i davit International\'ın can kurtaran vinçleri',
    rescuePropertyEquipment: 'Kurtarma mülkü ve ekipmanı',
    firefightingEquipmentSystems: 'Yangınla mücadele ekipmanı, sistemleri ve malzemeleri',
    radioNavigationEquipment: 'Radyo ve navigasyon ekipmanı',
    personalProtectionDevices: 'Bireysel koruma araçları',
    breathingApparatus: 'Solunum cihazı',
    embarkationPilotLadders: 'İniş ve pilot merdivenleri',
    multiTurnFasteners: 'Çok turlu bağlantı elemanları',
    firefightingEquipmentReinspection: 'Yangınla Mücadele Ekipmanlarının Yeniden Muayenesi ve Onarımı',
    emergencyEquipmentSupply: 'Acil Durum Ekipman Temini',
    firefightingHoseSupplyRepair: 'Yangınla Mücadele Ekipmanının - Hortumların Temini, Onarımı ve Sertifikasyonu',
    fireExtinguishingSystemsMaintenance: 'Yangın Söndürme Sistemleri Bakım ve Sertifikalandırma',
    lifeboatMaintenanceCertification: 'Can Kurtarma Filikaları ve İndirme Donanımları Bakım ve Sertifikalandırma',
    liferaftService: 'Can Salı Servisi',
    craneLoadTests: 'Kreyn Yük Testleri',
    gasDetectorCalibration: 'Gaz Dedektörleri Kalibrasyon Bakım ve Onarımları',
    gmdssRadioSurvey: 'GMDSS Radyo Sörvey',
    magneticCompassService: 'Manyetik Pusula Servis ve Bakımları',
    underwaterImagingSurvey: 'Sualtı Görüntüleme ve Sörvey',
    foamWaterAnalysis: 'Köpük ve Su Analizleri',
    
    // Service Descriptions
    firefightingEquipmentReinspectionDesc: 'Gemilerdeki yangın söndürme ekipmanlarının periyodik kontrolü, bakımı ve onarımı. SOLAS ve MED standartlarına uygun muayene ve sertifikalandırma hizmetleri.',
    emergencyEquipmentSupplyDesc: 'Acil durumlarda ihtiyaç duyulan tüm güvenlik ekipmanlarının hızlı temini. 7/24 hizmet ile kritik durumlarda anında destek sağlanması.',
    firefightingHoseSupplyRepairDesc: 'Yangın hortumlarının temini, basınç testleri, onarımı ve sertifikasyonu. Uluslararası standartlara uygun kalite kontrol süreçleri.',
    fireExtinguishingSystemsMaintenanceDesc: 'CO2, köpük, su spreyi ve diğer yangın söndürme sistemlerinin bakımı, testleri ve sertifikalandırması. Sistem performans optimizasyonu.',
    lifeboatMaintenanceCertificationDesc: 'Can kurtarma filika ve botlarının bakımı, davit sistemlerinin kontrolü ve sertifikalandırması. Güvenlik testleri ve performans değerlendirmesi.',
    liferaftServiceDesc: 'Can sallarının periyodik servisi, şişirme testleri, ekipman kontrolü ve yenileme işlemleri. Onaylı servis istasyonunda profesyonel hizmet.',
    craneLoadTestsDesc: 'Gemi vinç ve kaldırma ekipmanlarının yük testleri, güvenlik kontrolü ve sertifikalandırması. Yapısal dayanıklılık ve operasyonel güvenlik testleri.',
    gasDetectorCalibrationDesc: 'Gaz algılama cihazlarının kalibrasyonu, bakımı ve onarımı. Hassasiyet testleri ve alarm sistemlerinin kontrolü.',
    gmdssRadioSurveyDesc: 'GMDSS radyo ekipmanlarının sörvey ve sertifikalandırması. Haberleşme sistemlerinin performans testleri ve uygunluk kontrolü.',
    magneticCompassServiceDesc: 'Manyetik pusulaların ayarlanması, deviasyon tablosu hazırlanması ve bakım hizmetleri. Navigasyon doğruluğunun sağlanması.',
    underwaterImagingSurveyDesc: 'Sualtı görüntüleme teknolojileri ile gemi gövdesi incelemesi ve hasar tespiti. Dalış yapmadan güvenli muayene hizmetleri.',
    foamWaterAnalysisDesc: 'Yangın söndürme köpüğü ve suyunun kalite analizi, kimyasal kompozisyon kontrolü ve etkinlik testleri. Laboratuvar destekli analiz hizmetleri.',
    
    // Service Advantages
    serviceAdvantages: 'Hizmet Avantajları',
    successfulServicesProjects: 'Uzun yıllar boyunca başarılı hizmetler ve projeler',
    internationalMemberships: 'Şirket uluslararası birliklere üyedir',
    qualifiedCertifications: 'Nitelikli topluluklar LR, GL, BV, RS, URS tarafından verilen ödüller',
    licenses: 'Lisanslar',
    twentyFourSevenService: 'Çalışmalar 24 saat (7/24) yapılır',
    experiencedQualifiedStaff: 'Servis personeli deneyimli, kalifiye uzmanlardır',
    
    // Supply
    supply: 'Tedarik',
    firefightingRescueProductsStock: 'İtfaiye ve kurtarma ürünleri ve yedek parça stoklarımız var – her zaman stokta gerekli miktarda',
    directDeliveriesLeadingCompanies: 'Önde gelen şirketlerden doğrudan teslimatlar',
    diagnosisRepairStation: 'Teşhis ve onarım istasyonu',
    istanbulPortsDelivery: 'İstanbul\'un tüm limanlarında yedek parça ve ekipmanların kendi nakliyesi ile çıkarılması ve teslimi',
    professionalEquipmentSpareParts: 'Önde gelen firmalardan profesyonel ekipman ve yedek parçalar',
    ownSpecialTransportation: 'Kendi özel taşımacılığı'
  },
  en: {
    // Navigation
    home: 'Home',
    about: 'About Us',
    products: 'Our Products',
    media: 'Media',
    contact: 'Contact',
    certificates: 'Certificates',
    
    // Homepage
    heroTitle: 'Aymer Safety',
    heroSubtitle: 'Maritime fire safety systems',
    statsTitle: 'Aymer Safety in Numbers',
    experienceYears: 'Years of Experience',
    completedProjects: 'Completed Projects',
    happyCustomers: 'Happy Customers',
    countries: 'Countries',
    servicesTitle: 'Our Service Areas',
    fireDetectionService: 'Fire Detection',
    fireDetectionDesc: 'Early warning systems with modern technology',
    fireExtinguishingService: 'Fire Extinguishing',
    fireExtinguishingDesc: 'Effective and rapid response systems',
    marineEquipmentService: 'Marine Equipment',
    marineEquipmentDesc: 'International standard safety equipment',
    whyChooseTitle: 'Why Choose Aymer Safety?',
    securityPriority: 'Security Priority',
    securityPriorityDesc: 'We serve with the highest security standards.',
    marineExpertise: 'Marine Expertise',
    marineExpertiseDesc: 'Professional solutions with years of experience.',
    fireSafety: 'Fire Safety',
    fireSafetyDesc: 'Fire protection systems with modern technology.',
    ctaTitle: 'Contact Us for Your Projects',
    ctaDescription: 'Meet our expert team in maritimSafety fire safety systems and discover the most suitable solutions for your projects.',
    contactUs: 'Contact Us',
    
    // About
    aboutTitle: 'About Us',
    aboutContent1: 'Aymer Safety was established in 2019 in the Istanbul, Tuzla shipyard region. Since its establishment, it first started to serve factories, workshops and shopping centers in the land sector. Later, it undertook fire detection systems, camera systems and fire extinguishing systems services for factories, municipalities and hotels. Rapidly growing Aymer took its first steps in the maritime sector with its team of experts with experience in ship captaincy, sales management and technical management in local markets.',
    aboutContent2: 'Aymer Shipping has made a name for itself with its quality and trust approach that attracts the attention of its customers. Later, it expanded its product portfolio and started importing. During this time, it had the opportunity to serve many domestic and foreign fleet companies. Aymer, which has come a long way in a short time, will continue on its way at full speed by adopting its principles. Our company serves with a total of 380 m2 office and warehouse to provide the best service. It is covered by a 2-year warranty.',
    aboutContent3: 'All materials used in our company are CE approved.',
    aboutThankYou: 'THANK YOU FOR CHOOSING US',
    whoAreWe: 'WHO ARE WE?',
    moreInfo: 'More Information',
    numbersTitle: 'AYMER Safety IN NUMBERS',
    vision: 'Vision',
    mission: 'Mission',
    visionText: 'To become a global leader in maritime fire safety systems and provide innovative solutions that combine technology with safety.',
    missionText: 'To provide quality products and professional services while protecting our customers\' life and property safety at the highest level. To raise safety standards in the maritime industry.',
    companyValues: 'Our Values',
    quality: 'Quality',
    qualityDesc: 'Products and services at the highest quality standards',
    reliability: 'Reliability',
    reliabilityDesc: 'Reliable solutions focused on customer satisfaction',
    innovation: 'Innovation',
    innovationDesc: 'Innovative approach following technological developments',
    
    // Team
    ourTeam: 'Our Team',
    generalManager: 'General Manager',
    personnelManager: 'Personnel Manager',
    TeknikMüdür: 'Technical Manager-Captain',
    accountantManager:'Accountant',
    
    // Products
    productsTitle: 'Our Products',
    fireExtinguishers: 'Fire Extinguishers',
    fireDetectionSystems: 'Fire Detection Systems',
    fireExtinguishingSystems: 'Fire Extinguishing Systems',
    fireFightingEquipments: 'Fire Fighting Equipments',
    lifeSavingAppliances: 'Life Saving Appliances (LSA)',
    chartsPublications: 'Charts And Publications',
    personalProtectiveEquipments: 'Personal Protective Equipments',
    medicalEquipments: 'Medical Equipments',
    electronicEquipments: 'Electronic Equipments',
    ispsEquipments: 'ISPS Equipments',
    storageBoxEquipments: 'Storage Box And Equipments',
    oilSpillEquipments: 'Oil Spill Equipments',
    
    // Media
    mediaTitle: 'Media Gallery',
    mediaSubtitle: 'Visual and video content about our projects, products and services',
    
    
    // Contact
    contactTitle: 'Contact',
    location: 'Location',
    officeLocation: 'Our Office Location',
    officeLocationDesc: 'We serve from our Tuzla, Istanbul headquarters',
    openInMaps: 'Open in Google Maps',
    companyInfo: 'Company Information',
    address: 'Address',
    phone: 'Phone',
    email: 'Email',
    contactForm: 'Contact Form',
    name: 'Name',
    surname: 'Surname',
    yourEmail: 'Your Email',
    message: 'Your Message',
    send: 'Send',
    
    // Footer
    quickLinks: 'Quick Links',
    contactInfo: 'Contact Information',
    services: 'Our Services',
    footerDescription: 'We provide expert solutions in fire safety systems for the maritime industry. Your safety is our priority with over 25 years of experience.',
    fireDetectionSystems: 'Fire Detection Systems',
    fireExtinguishingSystems: 'Fire Extinguishing Systems',
    emergencyLighting: 'Emergency Lighting',
    safetyEquipments: 'Safety Equipment',
    marineElectronics: 'Marine Electronics',
    protectiveClothing: 'Protective Clothing',
    privacyPolicy: 'Privacy Policy',
    termsOfUse: 'Terms of Use',
    cookiePolicy: 'Cookie Policy',
    allRightsReserved: 'All rights reserved.',
    
    // Company Info
    companyAddress: 'İçmeler Mah. Göktürk Cad. No 76/A Tuzla/Istanbul/Türkiye',
    companyPhone: '+90 216 392 28 93 / +90 546 833 56 66',
    companyEmail: 'info@aymersafety.com',
    
    // Services
    servicesWeProvide: 'Services We Provide',
    inspectionRepairCertification: 'Inspection, Repair and Certification',
    inflatableLifesavingAppliances: 'Inflatable lifesaving appliances: davit-launched and throw-overboard liferafts (and other manufacturers), rescue boats, life jackets',
    dawitLifeboatWinches: 'D-i davit International\'s lifeboat winches',
    rescuePropertyEquipment: 'Rescue property and equipment',
    firefightingEquipmentSystems: 'Firefighting equipment, systems and materials',
    radioNavigationEquipment: 'Radio and navigation equipment',
    personalProtectionDevices: 'Personal protection devices',
    breathingApparatus: 'Breathing apparatus',
    embarkationPilotLadders: 'Embarkation and pilot ladders',
    multiTurnFasteners: 'Multi-turn fastening elements',
    firefightingEquipmentReinspection: 'Firefighting Equipment Re-inspection and Repair',
    emergencyEquipmentSupply: 'Emergency Equipment Supply',
    firefightingHoseSupplyRepair: 'Firefighting Equipment - Hose Supply, Repair and Certification',
    fireExtinguishingSystemsMaintenance: 'Fire Extinguishing Systems Maintenance and Certification',
    lifeboatMaintenanceCertification: 'Lifeboat and Launching Equipment Maintenance and Certification',
    liferaftService: 'Liferaft Service',
    craneLoadTests: 'Crane Load Tests',
    gasDetectorCalibration: 'Gas Detector Calibration Maintenance and Repairs',
    gmdssRadioSurvey: 'GMDSS Radio Survey',
    magneticCompassService: 'Magnetic Compass Service and Maintenance',
    underwaterImagingSurvey: 'Underwater Imaging and Survey',
    foamWaterAnalysis: 'Foam and Water Analysis',
    
    // Service Descriptions
    firefightingEquipmentReinspectionDesc: 'Periodic inspection, maintenance and repair of firefighting equipment on ships. Inspection and certification services in accordance with SOLAS and MED standards.',
    emergencyEquipmentSupplyDesc: 'Rapid supply of all safety equipment needed in emergencies. Immediate support in critical situations with 24/7 service.',
    firefightingHoseSupplyRepairDesc: 'Supply, pressure testing, repair and certification of fire hoses. Quality control processes in accordance with international standards.',
    fireExtinguishingSystemsMaintenanceDesc: 'Maintenance, testing and certification of CO2, foam, water spray and other fire extinguishing systems. System performance optimization.',
    lifeboatMaintenanceCertificationDesc: 'Maintenance of lifeboats and rescue boats, control and certification of davit systems. Safety tests and performance evaluation.',
    liferaftServiceDesc: 'Periodic service of life rafts, inflation tests, equipment control and renewal operations. Professional service at approved service station.',
    craneLoadTestsDesc: 'Load testing, safety control and certification of ship cranes and lifting equipment. Structural durability and operational safety tests.',
    gasDetectorCalibrationDesc: 'Calibration, maintenance and repair of gas detection devices. Sensitivity tests and alarm system controls.',
    gmdssRadioSurveyDesc: 'Survey and certification of GMDSS radio equipment. Performance testing and compliance control of communication systems.',
    magneticCompassServiceDesc: 'Adjustment of magnetic compasses, preparation of deviation tables and maintenance services. Ensuring navigation accuracy.',
    underwaterImagingSurveyDesc: 'Ship hull inspection and damage detection with underwater imaging technologies. Safe inspection services without diving.',
    foamWaterAnalysisDesc: 'Quality analysis of firefighting foam and water, chemical composition control and effectiveness tests. Laboratory-supported analysis services.',
    
    // Service Advantages
    serviceAdvantages: 'Service Advantages',
    successfulServicesProjects: 'Successful services and projects for many years',
    internationalMemberships: 'Company is a member of international associations',
    qualifiedCertifications: 'Awards given by qualified communities LR, GL, BV, RS, URS',
    licenses: 'Licenses',
    twentyFourSevenService: 'Works are carried out 24 hours (24/7)',
    experiencedQualifiedStaff: 'Service personnel are experienced, qualified experts',
    
    // Supply
    supply: 'Supply',
    firefightingRescueProductsStock: 'We have firefighting and rescue products and spare parts stocks – always the required amount in stock',
    directDeliveriesLeadingCompanies: 'Direct deliveries from leading companies',
    diagnosisRepairStation: 'Diagnosis and repair station',
    istanbulPortsDelivery: 'Removal and delivery of spare parts and equipment with own transportation in all ports of Istanbul',
    professionalEquipmentSpareParts: 'Professional equipment and spare parts from leading companies',
    ownSpecialTransportation: 'Own special transportation'
  }
};

export const LanguageProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [language, setLanguage] = useState<Language>('tr');

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'tr' ? 'en' : 'tr');
  };

  const t = (key: string): string => {
    return translations[language][key as keyof typeof translations['tr']] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};